<template>
  <div v-if="hasCoordinates || hasAddressParts">
    <a :href="googleMapsUrl" target="_blank" rel="noopener noreferrer" class="btn btn-outline-primary btn-sm">
      View on Google Maps
      <i class="ms-1 bi bi-box-arrow-up-right"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'GoogleMapsLink',
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasCoordinates() {
      return (this.address.latitude && this.address.longitude) || 
             (this.address.coordinates && this.address.coordinates.lat && this.address.coordinates.lon);
    },
    
    hasAddressParts() {
      return this.address.line1 || this.address.city || this.address.suburb;
    },
    
    googleMapsUrl() {
      // Check for coordinates in both formats (nested or direct)
      const hasDirectCoordinates = this.address.latitude && this.address.longitude;
      const hasNestedCoordinates = this.address.coordinates && this.address.coordinates.lat && this.address.coordinates.lon;
      
      // If we have coordinates, use them for better accuracy
      if (hasDirectCoordinates) {
        return `https://www.google.com/maps?q=${this.address.latitude},${this.address.longitude}`;
      } else if (hasNestedCoordinates) {
        return `https://www.google.com/maps?q=${this.address.coordinates.lat},${this.address.coordinates.lon}`;
      }
      
      // Otherwise, build address string for search
      const addressParts = [];
      if (this.address.line1) addressParts.push(this.address.line1);
      if (this.address.line2) addressParts.push(this.address.line2);
      if (this.address.suburb) addressParts.push(this.address.suburb);
      if (this.address.city) addressParts.push(this.address.city);
      addressParts.push('New Zealand');
      
      const addressString = addressParts.join(', ');
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressString)}`;
    },
  },
};
</script>